import React from 'react';
import { withStyles } from '@material-ui/styles';
import {
  Grid,
  Button,
  Dialog,
  Slide,
  Toolbar,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';

import SubscribeButton from '../../components/SubscribeButton';
import apiManager from '../../../src/ApiManager';
import { getParameterByName } from '../../utils/utils';
import moment from 'moment';
import SubContent from './components/SubContent';
import RegenAg10101 from '../../assets/classes/regenAg101-01.json';
// import ag101Logo from '../../images/SHA/ag101logo.png';
import {
  ORGANIZATION_ALIAS,
  HORIZONTAL_LOGO as ag101Logo,
  LOGO_ONLY,
} from '../../constants';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';

// Stripe Checkout Config - Rest is Handled via systemSettings
import { STAGE, STRIPE_BASE_URL } from '../../constants';
import LoadingIndicator from '../../components/LoadingIndicator';
import RenewButton from '../../components/RenewButton';
const BASE_URL = STRIPE_BASE_URL;

const styles = theme => ({
  root: {
    // textAlign: 'center',
    fontFamily: 'Helvetica',
    paddingTop: 100,
    '@media only screen and (max-width: 450px)': {
      marginLeft: 0,
    },
  },
  pageTitle: {
    fontWeight: 'bold',
    fontSize: 24,
    width: '100%',
    margin: '18px auto',
  },

  cardtitle: {
    fontWeight: 500,
    fontSize: 24,
    color: '#555',
    marginBottom: 32,
    marginLeft: 24,
    textAlign: 'left',
    border: '1px solid #ddd',
    borderRadius: 5,
    padding: 12,
  },

  explain: {
    margin: 18,
    fontStyle: 'italic',
    width: '80%',
    fontSize: 16,
    textAlign: 'left',
    lineHeight: '20px',
  },
  myclassesbox: {
    borderRadius: 8,
    border: '1px solid #c8c8c8',
    padding: 18,
    textAlign: 'center',
    margin: 12,
    marginLeft: 24,
  },
  courselist: {
    display: 'flex',
    fontSize: 18,
    margin: '18px',
    justifyContent: 'space-between',
    columnGap: '20px',
  },
});

export class HomeUser extends React.PureComponent {
  constructor(...args) {
    super(...args);
    this._logoutTimerID = null;
    this._logoutIntervalID = null;

    const { user, apiManager, history, updateUser } = this.props;
    const testDate = getParameterByName('test-date');
    const demoMode = localStorage.getItem('demoMode') || false;
    this.state = {
      user, // TODO: Not set yet. Need to adjust udpateUser to used Cognito info to pull in info from DB.
      apiManager,
      history,
      isLoading: true,
      search: '',
      newName: '',
      myNarratives: [],
      token: '',
      subExp: null,
      testDate,
      organization: { courses: [] },
      subscriptions: [], // these will be the course alias names for any active subsriptions
      subscriptionData: {},
      selectedCourses: [],
      openCart: false,
      demoMode,
    };
  }
  
  componentDidMount = async () => {
    // Get the current JWT
    document.addEventListener('pageshow', (event) => {if (event.persisted) {
      window.location.reload() 
    }})
    const attributes = await apiManager.currentAttributes();
    const { accessToken, idToken } = await apiManager.currentSession();
    const { payload } = idToken;
    const id = this.state.user['sub'];
    const userMe = await apiManager.getUserMe(id, ORGANIZATION_ALIAS);
    const now = moment();
    let isExpired = false;
    const subscriptions = [];
    const subscriptionData = {};
    const stripeSubs = [];
    if (userMe && userMe.registrations) {
      userMe.registrations.forEach(reg => {
        if (
          reg.organization &&
          (reg.organization.name === ORGANIZATION_ALIAS ||
            reg.organization.name === 'sha') &&
          reg.organization.subscriptions &&
          reg.organization.subscriptions.length > 0
        ) {
          reg.organization.subscriptions.forEach(sub => {
            // Need to ensure that an unsub will actuall be isSubscribed or move the isExpired info somewhere else
            if (sub.isSubscribed === true) {
              subscriptions.push(sub.courseNameAlias);
              subscriptionData[sub.courseNameAlias] = sub;
              if (sub.processedBy !== 'Manual') {
                stripeSubs.push(sub.courseNameAlias);
              }
              if (sub.status === 'cancelled' || now.isAfter(sub.endDate)) {
                subscriptionData[sub.courseNameAlias].isExpired = true;
                console.log(
                  'Subscription expired: ',
                  sub.status,
                  moment(sub.endDate).format('mm/dd/yy')
                );
              }
            }
          });
        }
      });
    }
    // find the subscriptions for this user
    // const manualSubscription = userMe && userMe.registrations && userMe.registrations[0] && userMe.registrations[0].organization && userMe.registrations[0].organization.subscriptions && userMe.registrations[0].organization.subscriptions[0] ? userMe.registrations[0].organization.subscriptions[0] : ''

    // const hasManualSubscription = manualSubscription && manualSubscription.isSubscribed && !moment().isAfter(moment(manualSubscription.endDate * 1000))

    // NO LONGER LOOKING AT STRIPE SUBS AT ALL
    // const hasStripeSub = attributes['custom:isSubscribed'] && attributes['custom:isSubscribed'] === 'true'

    //If there is a manual sub, use it instead of stripe.
    // const isSubscribed = manualSubscription ? hasManualSubscription : hasStripeSub

    const newUser = {
      token: accessToken.jwtToken,
      firstName: attributes['custom:firstName'],
      lastName: attributes['custom:lastName'],
      email: attributes['email'],
      phone: attributes['custom:phone'],
    };

    const settings = await apiManager.getSystemSettings(ORGANIZATION_ALIAS);
    console.log('settings', settings);

    const organization =
      settings && settings.results && settings.results.org
        ? settings.results.org
        : [];
    const jsonString =
      settings && settings.results && settings.results.org
        ? JSON.stringify(settings.results.org)
        : '';
    localStorage.setItem('organization', jsonString);
    localStorage.setItem(
      'subscriptionData',
      subscriptions.length > 0 ? JSON.stringify(subscriptionData) : ''
    );

    let availableSubscriptions = 0;
    organization.courses.forEach(c => {
      if (now.isSameOrAfter(c.available)) {
        availableSubscriptions++;
      }
    });

    this.setState({
      user: newUser,
      token: accessToken.jwtToken,
      subExp: Number(attributes['custom:subExp']),
      organization,
      subscriptionData,
      subscriptions,
      stripeSubs,
      isExpired,
      isLoading: false,
      availableSubscriptions: availableSubscriptions - subscriptions.length,
    });
    // console.log('SES: ', payload['custom:isSubscribed'] === 'true', payload['custom:subExp']);
    // this.props.updateUser(newUser);
    const it = await apiManager.getCourseSettings(
      'price_1JpciuADndcRBW2uj9AJ8kpy'
    );
    console.log('it return', it);
  };
  componentWillUnmount() {
    document.removeEventListener('pageshow', (event) => {if (event.persisted) {
      window.location.reload() 
    }})
  }
  handleNameInput = event => {
    event.persist();

    this.setState({ newName: event.target.value });
  };

  onCloseCart = () => {
    this.setState({ openCart: false });
  };

  isSelectedCourse = alias => {
    let response = false;
    this.state.selectedCourses.forEach(course => {
      if (course.course === alias) {
        response = course;
      }
    });
    return response;
  };

  selectedCoursePrice = alias => {
    let response = [];

    this.state.selectedCourses.forEach(course => {
      if (course.course === alias) {
        const price = course.stripe[course.stripe.basicProductPlan]; //.reduce((accumulator, curr) => accumulator + curr);
        response.push(`Full Price: $${price}`);
        if (
          this.state.stripeSubs.length > 0 ||
          this.state.selectedCourses.length > 1
        ) {
          const discount =
            price - course.stripe[course.stripe.basicProductPlanBundle];
          response.push(`Multi-course discount: $${discount}`);
        }
      }
    });
    return response;
  };

  handleStripeCheckout = async () => {
    // This function assumes that there's at least one product in the selectedCourses array
    // as the checkout button is grayed out until a course is clicked on. :)
    // Configure Stripe
    const stripeConfig = this.state.organization.organization.stripeConfig;
    const STRIPE_PUBLIC_KEY = stripeConfig.publicKey;
    const stripe = window.Stripe(STRIPE_PUBLIC_KEY);
    console.log('courses to subscribe to: ', this.state.selectedCourses);

    // Start Spinner
    // setLoading(true);

    const attributes = await apiManager.currentAttributes();
    const { accessToken } = await apiManager.currentSession();
    const successUrl = `${BASE_URL}/subscription/success/{CHECKOUT_SESSION_ID}/`;
    const webUrl = `${BASE_URL}`;
    // alert(JSON.stringify(attributes));
    // alert(`${successUrl}?id={CHECKOUT_SESSION_ID}&user=` + encodeURIComponent(accessToken.jwtToken));

    // Create Stripe Checkout Session Template
    const sessionTemplate = {
      customerEmail: attributes['email'],
      customerPhone:
        attributes && attributes['custom:phone']
          ? attributes['custom:phone']
          : '',
      customerReferralURL: localStorage.getItem('referrerURL'),
      token: accessToken.jwtToken,
      successUrl:
        `${successUrl}?id={CHECKOUT_SESSION_ID}&user=` +
        encodeURIComponent(accessToken.jwtToken),
      cancelUrl: webUrl + '/subscription/error', // /#error
    };
    // Generate Line Items for Stripe
    const lineItems = this.state.selectedCourses.map(course => {
      return { price: course.isRenewal ? course.stripe.basicProductPlanRenewal : course.stripe.basicProductPlan, quantity: 1 };
    });
    sessionTemplate.lineItems = lineItems;
    console.log(`lineItems: ${JSON.stringify(lineItems)}`);

    const paidSubscriptions = this.state.subscriptions.filter(
      sub => this.state.subscriptionData[sub].processedBy !== 'Manual'
    );
    // If there's at least one subscription already
    // or if there's more than one product specific discounts to implement course bundles.
    if ((paidSubscriptions.length > 0 || lineItems.length > 1)) {
      // STRIPE ONLY ALLOWS ONE DISCOUNT AT A TIME BUT WANTS YOU TO PASS IN AS AN ARRAY...GO FIGURE.

      let discount = 0;
      this.state.selectedCourses.forEach(course => {
        if (!course.isRenewal){
          const d = course.stripe[course.stripe.basicProductPlanBundle];
          discount += d;
        } else {
          discount = 0;
        }
      });
      if (discount > 300) discount = 300;
      const bundle = `bundle${discount}`;
      sessionTemplate.discounts = [{ coupon: stripeConfig[bundle] }]; // TODO: Calculate discount for different bundle coupons. Can't send more than 1 :(
      console.log(
        `Bundle discounts: ${JSON.stringify(sessionTemplate.discounts)}`
      );
    }

    const session = await apiManager.createCheckoutSession(sessionTemplate);
    console.log(session);

    // OLD VERSION FOR REFERENCE:
    // Call create-checkout-session for more custom experience
    // returns session to be used in redirectToCheckout
    // const session = await apiManager.createCheckoutSession({
    //   lineItems: [{ price: productId, quantity: 1 }],
    //   customerEmail: attributes['email'],
    //   customerPhone: (attributes && attributes['custom:phone']) ? attributes['custom:phone'] : '',
    //   customerReferralURL: localStorage.getItem('referrerURL'),
    //   token: accessToken.jwtToken,
    //   successUrl: `${successUrl}?id={CHECKOUT_SESSION_ID}&user=` + encodeURIComponent(accessToken.jwtToken),
    //   cancelUrl: webUrl + '/subscription/error', // /#error
    // });

    if (session && session.id) {
      stripe.redirectToCheckout({ sessionId: session.id });
    } else {
      // setLoading(false);
      alert(
        'There was a problem with initializing the checkout page. Please contact support at: support@regenagonline.com'
      );
    }
  };

  removeCourseFromCart = item => {
    //  const toRemove = this.state.selectedCourses.indexOf((item, i) => item.course === this.state.selectedCourses[i].course)
    let toRemove = -1;
    this.state.selectedCourses.forEach((course, index) => {
      if (course.course === item.course) toRemove = index;
    });
    if (toRemove >= 0) {
      let removed = [...this.state.selectedCourses];
      removed.splice(toRemove, 1);
      console.log(removed);
      this.setState({
        selectedCourses: removed,
      });
    }
  };

  handleClassClick = (item, isRenewal = false) => {
    // if this is the ONLY option, go directly to the paywall.
    // otherwise, pop open the "cart"
    // alert(`Subscriptions available: ${this.state.availableSubscriptions}`)
    let selected = this.state.selectedCourses;
    if (!this.isSelectedCourse(item.alias)) {
      // only add it in if it's not already there!
      selected = [
        ...this.state.selectedCourses,
        { stripe: item.stripeConfig, course: item.alias, name: item.name, isRenewal },
      ];
    }
    this.setState(
      {
        selectedCourses: selected,
      },
      () => {
        if (this.state.availableSubscriptions > 1) {
          this.setState({ openCart: true });
          return;
        }
        this.handleStripeCheckout();
      }
    );
  };

  //
  addAllToCart = (coursesToAdd, goDirectlyToCart = false) => {
    let selected = this.state.selectedCourses;
    coursesToAdd.forEach(course => {
      if (!this.isSelectedCourse(course.alias)) {
        // only add it in if it's not already there!
        selected = [
          ...selected,
          {
            stripe: course.stripeConfig,
            course: course.alias,
            name: course.name,
          },
        ];
      }
    });
    this.setState(
      { selectedCourses: selected, isLoading: goDirectlyToCart },
      () => {
        if (goDirectlyToCart) {
          this.handleStripeCheckout();
        }
      }
    );
  };

  // handleClassSubscribeClick = (item, isRemove) => {
  //   if(!isRemove){
  //     const selected = [...this.state.selectedCourses, {stripe: item.stripeConfig, course: item.alias, name: item.name}]
  //     this.setState({
  //       selectedCourses: selected,
  //     })
  //   } else {
  //     const toRemove = this.state.selectedCourses.indexOf((item, i) => item.alias === this.state.selectedCourses[i].course)
  //     let removed = [...this.state.selectedCourses];
  //     removed.splice(toRemove, 1)
  //     console.log(removed)
  //     this.setState({
  //       selectedCourses: removed,
  //     })
  //   }

  // }

  dialogTransition = props => <Slide direction="left" {...props} />;

  renderMultiCourseDiscount = (fromHomePage = false) => {
    const { classes } = this.props;
    const now = moment();
    let total = 0;
    let lines = [];
    let coursesToAdd = [];
    this.state.organization.courses.forEach(c => {
      if (now.isSameOrAfter(c.available)) {
        // course available... is user subscribed?
        const stripe = c.stripeConfig;
        const price = stripe[stripe.basicProductPlan];
        const discount = price - stripe[stripe.basicProductPlanBundle];
        total += discount;
        lines.push({ course: c.name, price, discount });
        coursesToAdd.push(c);
      }
    });
    return (
      <div
        className={classes.cardtitle}
        style={{ marginTop: 24, paddingBottom: 0, border: '2px solid #67b1e2' }}
      >
        {lines.map(line => (
          <div className={classes.courselist}>
            <div style={{ width: 240 }}>{line.course}</div>
            <div>Full Price: ${line.price}</div>
            <div>Multi-course discount: ${line.discount}</div>
          </div>
        ))}
        <hr />
        <div className={classes.courselist} style={{ fontWeight: 'bold' }}>
          <div>TOTAL WITH DISCOUNT</div>
          <div>${total}</div>
        </div>
        <div className={classes.courselist}>
          <div></div>
          <div>
            <Button
              variant="contained"
              color="primary"
              size="small"
              style={{ margin: 12 }}
              onClick={() => this.addAllToCart(coursesToAdd, fromHomePage)}
            >
              {`${fromHomePage ? 'Subscribe to All' : 'Add All to Cart'}`}
            </Button>
          </div>
          <div></div>
        </div>
      </div>
    );
  };

  renderCart = () => {
    const { classes } = this.props;
    const { subscriptions, subscriptionData } = this.state;
    const now = moment();

    return (
      <>
        <div className="breefly--cart-dialog">
          <div className="breefly--cart-titlebar" onClick={this.onCloseCart}>
            <div style={{ flexGrow: 0 }}>&nbsp;</div>
            <div style={{ flexGrow: 0 }}>YOUR CART</div>
            <div style={{ flexGrow: 0 }}>
              <IconButton
                onClick={this.onCloseCart}
                aria-label="Close"
                className="breefly--cart-close"
              >
                <CloseIcon />
              </IconButton>
              {/* <span
                className="realm--appbar-name"
                style={{ fontSize: this.state.isMobile ? 16 : 24 }}
              >
                Close 
              </span> */}
            </div>
          </div>
        </div>
        <Grid container>
          <Grid item xs={8} className="breefly--cart-cart">
            <h2>Your Cart</h2>
            <div style={{ margin: 60 }}>
              {/* {this.state.selectedCourses.length === 0 ? <div>No courses selected</div> : this.state.selectedCourses.map(el => {
                if (this.state.selectedCourses.length < 1) {
                  return 'No courses selected'
                }
                else if (this.state.selectedCourses.length === 1) {
                  return <div>{el.name}: ${el.stripe[el.stripe.basicProductPlan]}</div>
                } else {
                  return (
                    <div>{el.name}: ${<span style={{ textDecoration: 'line-through' }}>{el.stripe[el.stripe.basicProductPlan]}</span>} {el.stripe[el.stripe.basicProductPlan] - el.stripe[el.stripe.basicProductPlanBundle]}</div>
                  )
                }
              }
              )} */}
              {this.state.organization.courses &&
                this.state.organization.courses.map((course, index) => (
                  <Grid item sm={12} key={course.alias}>
                    {!subscriptions.includes(course.alias) &&
                      now.isSameOrAfter(course.available) &&
                      this.isSelectedCourse(course.alias) !== false && (
                        <div className={classes.cardtitle}>
                          <div className={classes.courselist}>
                            {/* {course.name} */}
                            <div>
                              {' '}
                              <img src={course.logo} width="150px" />
                            </div>
                            <div>
                              <img src={course.thumbnail} width="150" />
                            </div>
                            <div className="breefly--cart-course">
                              {course.description}
                            </div>
                            <div style={{ marginRight: 18 }}>
                              {this.selectedCoursePrice(course.alias).map(
                                message => (
                                  <div>{message}</div>
                                )
                              )}
                              <Button
                                onClick={() =>
                                  this.removeCourseFromCart(
                                    this.isSelectedCourse(course.alias)
                                  )
                                }
                                size="small"
                                color="secondary"
                                style={{ width: 200, marginTop: 24 }}
                              >
                                Remove
                              </Button>
                            </div>
                          </div>
                        </div>
                      )}
                  </Grid>
                ))}
              {this.state.availableSubscriptions -
                this.state.selectedCourses.length >
                0 && (
                <>
                  <hr style={{ borderColor: '#67b1e2', margin: '18px 0px' }} />
                  <h3>Subscribe to Multiple Courses and Save!</h3>
                  {this.renderMultiCourseDiscount()}
                </>
              )}
            </div>
          </Grid>
          <Grid item xs={4} className="breefly--cart-checkout-panel">
            <h2>Confirm Your Order</h2>
            <div style={{ marginTop: 48 }}>
              Total: $
              {this.state.selectedCourses.length === 1
                ? this.state.selectedCourses[0].stripe[
                    this.state.selectedCourses[0].stripe.basicProductPlan
                  ]
                : this.state.selectedCourses.length > 1
                ? this.state.selectedCourses
                    .map(
                      (el, index) =>
                        this.state.selectedCourses[index].stripe[
                          el.stripe.basicProductPlan
                        ]
                    )
                    .reduce((accumulator, curr) => accumulator + curr) -
                  this.state.selectedCourses
                    .map(
                      (el, index) =>
                        this.state.selectedCourses[index].stripe[
                          el.stripe.basicProductPlanBundle
                        ]
                    )
                    .reduce((accumulator, curr) => accumulator + curr)
                : 0}
            </div>
            <Button
              type="submit"
              // style={styling}
              id={`start-stripe-checkout`}
              disabled={this.state.selectedCourses.length === 0}
              onClick={this.handleStripeCheckout}
              size="medium"
              fullWidth
              color="primary"
              variant={'contained'}
              style={{ width: 300, marginTop: '1rem' }}
            >
              Check Out
            </Button>
          </Grid>
        </Grid>
      </>
    );
  };

  render() {
    const { classes } = this.props;
    // console.log('SES: ', this.state);
    const { subscriptions, subscriptionData } = this.state;
    // let courseUrl = '/myclasses?class=regenag101-01';
    let courseUrl = '/myclasses?course=';
    if (this.state.testDate) {
      courseUrl = `${courseUrl}&test-date=${this.state.testDate}`;
    }

    const now = moment();

    return (
      <div className={classes.root}>
        <div className="unsubContent">
          {/* content */}
          <Grid container spacing={0}>
            <div className={classes.pageTitle}>
              Regen Ag Online Series Available Courses
            </div>
            <Grid item sm={12}>
              {this.state.isLoading ? (
                <LoadingIndicator />
              ) : (
                <>
                  {this.state.subscriptions.length === 0 && (
                    <>
                      <h3>Subscribe to All Available Courses Now and Save!</h3>
                      {this.renderMultiCourseDiscount(true)}
                      <hr
                        style={{
                          borderColor: '#67b1e2',
                          margin: '48px 0px 48px 24px',
                        }}
                      />
                      <h3 style={{ margin: 24 }}>
                        Subscribe to Individual Courses Below
                      </h3>
                    </>
                  )}
                  {this.state.organization.courses &&
                    this.state.organization.courses.map((course, index) => (
                      <Grid item sm={12} key={course.alias}>
                        <div className={classes.cardtitle}>
                          <div className={classes.courselist}>
                            {/* {course.name} */}
                            <div>
                              {' '}
                              <img src={course.logo} width="150px" />
                            </div>
                            <div>
                              <img src={course.thumbnail} width="150" />
                            </div>
                            <div style={{ marginLeft: 18, marginRight: 18 }}>
                              {course.description}
                            </div>
                            <div style={{ marginRight: 18, display: 'flex', flexFlow: 'column wrap', gap: 10 }}>
                              {subscriptions.includes(course.alias) ? (
                                <>
                                  <Button
                                    href={`${courseUrl}${course.alias}`}
                                    variant="contained"
                                    size="small"
                                    color="primary"
                                    style={{ width: 200 }}
                                  >
                                    {this.state.subscriptionData[course.alias]
                                      .isExpired
                                      ? 'View Progress'
                                      : 'Go To Course'}
                                  </Button>
                                  {this.state.subscriptionData[course.alias]
                                    .isExpired && (
                                    <RenewButton
                                      course={course}
                                      handleClassClick={this.handleClassClick}
                                      index={index}
                                      isRenewal={true}
                                    />
                                  )}
                                </>
                              ) : (
                                <>
                                  {now.isSameOrAfter(course.available) ? (
                                    <SubscribeButton
                                      course={course}
                                      handleClassClick={this.handleClassClick}
                                      index={index}
                                      showDiscount={
                                        this.state.subscriptions.length === 0 ||
                                        this.state.stripeSubs.length > 0 ||
                                        this.state.selectedCourses.length > 1
                                      }
                                    />
                                  ) : (
                                    <div
                                      style={{
                                        width: 200,
                                        textAlign: 'center',
                                      }}
                                    >
                                      Course available
                                      <br />
                                      {course.availableMessage ||
                                        moment(course.available).format(
                                          'MMM D, YYYY'
                                        )}
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </Grid>
                    ))}
                </>
              )}
            </Grid>
          </Grid>
        </div>
        <Dialog
          fullScreen
          onClose={this.onCloseCart}
          open={this.state.openCart}
          TransitionComponent={this.dialogTransition}
        >
          {this.state.openCart && this.renderCart()}
        </Dialog>
      </div>
    );
  }
}

HomeUser.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  apiManager: PropTypes.object,
  updateUser: PropTypes.func,
};

export default withStyles(styles)(HomeUser);
